import axios from "axios";
import { url } from "../../constants/config";

export const fetchStandings = division => {
  return {
    type: "FETCH_STANDINGS",
    meta: {
      division
    },
    payload: axios.get(url + "get_standings.php", {
      params: {
        division
      }
    })
  };
};



// WEBPACK FOOTER //
// ./src/store/standings/standingsActions.js